import "../style/index.scss";

import jQuery from "jquery";
import { setJqueryStatic } from "@de-xima/xima-common-js-dom";

import "@ksakira10/ripplejs/dist/ripple.css";
import "@ksakira10/ripplejs/dist/ripple.js";
import { ResizeSensor } from "css-element-queries";
import "jquery-textrange";
import "jquery-touchswipe";
import { debounce, throttle } from "lodash-es";

import "nanoscroller";
import "nanoscroller/bin/css/nanoscroller.css";

import Simplebar from "simplebar";
import "simplebar/dist/simplebar.css";

import * as GlobalExports from "./global-exports.ts";
import { OnDocumentReady } from "../core/OnDocumentReady.ts";

// TODO Move to JQueryDom, or just get rid of JQuery where possible
setJqueryStatic(jQuery);

// Activate ripple effect
jQuery.ripple("mousedown.ripple", {
  on: ".ripplelink,.ui-button,.ui-selectlistbox-item,.ui-multiselectlistbox-item",
});

// Expose window globals
(window as unknown as Record<string, unknown>).Simplebar = Simplebar;
(window as unknown as Record<string, unknown>).ResizeSensor = ResizeSensor;
// Probably only used once in the designer, can be removed soon
(window as unknown as Record<string, unknown>)._ = { debounce, throttle };

// Invoke other setup functionality when document is ready
jQuery(() => {
  OnDocumentReady();
});

const win = window as unknown as Record<string, unknown>;
if (!win.Formcycle) {
  win.Formcycle = {};
}
Object.assign(win.Formcycle as unknown as Record<string, unknown>, GlobalExports);
